/**
 * One page of a sheet is shown at a time, so a ✗, a flag or a line under review on another page needs something pointing at it
 * (the summary chips say only that one exists). This names those pages, and pressing one goes there. Page numbers, not counts.
 */

import { useHomeworkLabels } from '../../i18n/homework-labels.js';
import { useMessages } from '../../i18n/locale.js';
import type { BoardNote } from './feedback-blocks.js';
import { feedbackChrome } from './feedback-chrome.js';

/** A note a learner should be led to. A ✗ stays one after it is disputed, so disputing the only one does not move the page. */
export const needsALook = (note: BoardNote): boolean => note.kind === 'wrong' || note.kind === 'review' || note.flag !== undefined;

export function AlsoToLook({
  notes,
  pageIds,
  current,
  pageNumberOf,
  onGo,
}: {
  readonly notes: readonly BoardNote[];
  readonly pageIds: readonly string[];
  readonly current: string | undefined;
  readonly pageNumberOf: (pageId: string) => number;
  readonly onGo: (pageId: string) => void;
}): React.JSX.Element | null {
  const m = useMessages(feedbackChrome);
  const h = useHomeworkLabels();
  const others = pageIds.filter((id) => id !== current && notes.some((note) => note.pageId === id && needsALook(note)));
  if (others.length === 0) return null;
  return (
    <p className="fb-also">
      {m.alsoToLook}
      {others.map((id) => (
        <button key={id} type="button" className="fb-also-page" onClick={() => onGo(id)}>
          {h.pageN(pageNumberOf(id))}
        </button>
      ))}
    </p>
  );
}
